module.exports = __webpack_public_path__ + "img/PillMED.6f2e73c8.svg";